import PropTypes from 'prop-types';
import React from "react";
import 'intl';
import 'intl/locale-data/jsonp/en';
import url from 'url';

// Custom class for the result component
class FederatedResult extends React.Component {

  dateFormat(date){
    if (typeof date !== 'undefined') {
      const prettyDate =  new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      }).format(Date.parse(date));
      return prettyDate;
    }
  }

  // https://stackoverflow.com/questions/8358084/regular-expression-to-reformat-a-us-phone-number-in-javascript
  formatPhoneNumber(phoneNumberString) {
    let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      let intlCode = (match[1] ? '+1 ' : '');
      // return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
      return [match[2], '.', match[3], '.', match[4]].join('');
    }
    return null;
}

  /**
   * Returns the appropriate link for a given search result.
   * 1. Use the canonical url if present.
   * 2. Next, attempt to find a url from the current host.
   * 3. Then, use the first url returned in the array of urls.
   * 4. Fall back to the legacy url field.
   * 5. Send an empty string if none of these options work.
   *
   * @param doc
   *   Search result object
   * @returns string
   */
  getCanonicalLink(doc) {
    const { hostname } = this.props;

    // 1. Use the canonical url as a first option
    if (Object.hasOwnProperty.call(doc, 'ss_canonical_url') && doc.ss_canonical_url) {
      return doc.ss_canonical_url;
    }

    // Use a url from the current host, if present.  Otherwise use the first Url.
    if (Object.hasOwnProperty.call(doc, 'sm_urls') && Array.isArray(doc.sm_urls)) {
      // Attempt to find a url from the current host.
      const currentHostUrl = doc.sm_urls.find((item) => {
        const myUrl = url.parse(item);
        return myUrl.hostname === hostname;
      });

      // 2. Use the url from the current host.
      if (currentHostUrl) {
        return currentHostUrl;
      }

      // 3. Use the first url.
      return doc.sm_urls[0];
    }

    // 4. Fall back to the single url (which will be relative)
    if (Object.hasOwnProperty.call(doc, 'ss_url') && doc.ss_url) {
      return doc.ss_url;
    }
    console.log("test")
    // 5. If no valid urls are passed, return nothing. This will result in an
    // unlinked title, but at least it won't crash.
    return '';
  }

  intersperse(arr, sep) {
    if (arr.length === 0) {
      return [];
    }

    return arr.slice(1).reduce(function(xs, x, i) {
      return xs.concat([sep, x]);
    }, [arr[0]]);
  }

  renderSitenameLinks(sitenames, urls, originalSitename) {
    if (sitenames != null && urls != null) {
      var sites = [];
      for (var i = 0; i < sitenames.length; i++) {
        sites.push(<a className="tag site" href={urls[i]} key={i}>{sitenames[i]}</a>);
        if (i !== (sitenames.length - 1)) {

        }
      }
    }

    if (originalSitename != null) {
      return originalSitename;
    }

    return null;
  }

  render() {
    const { doc, highlight } = this.props;
    let departments = null;
    if (Array.isArray(doc.sm_department)){
      departments = doc.sm_department.join(" | ");
    }
    return (
      <li
        className="search-card search-card--default tile"
        onClick={() => this.props.onSelect(doc)}
      >
        <a href={this.getCanonicalLink(doc)}>

          <div className="text wrapper">
            {departments ? (
              <span className="department-tag">{departments}</span>
            ) : null}

            <h3 className="heading h5" dangerouslySetInnerHTML={{ __html: doc.ss_federated_type == 'Provider'
              ? doc.ss_sort_az_field
              : doc.ss_federated_title
            }}></h3>

            <p
              className="search-card__summary"
              dangerouslySetInnerHTML={{ __html: doc.ss_summary }}
            />

            <div className="meta tags tags--pipe">
              {doc.sm_federated_type ? (
                <span className="content-type-tag type">
                  {doc.sm_federated_type}
                </span>
              ) : null}

            </div>
          </div>
        </a>
      </li>
    );
  }
}

FederatedResult.propTypes = {
  doc: PropTypes.object,
  fields: PropTypes.array,
  onSelect: PropTypes.func.isRequired,
  hostname: PropTypes.string
};

export default FederatedResult;
